import { useEffect, useRef, useState } from 'react'

const useStatePrev = (initalState) => {
  const [state, setState] = useState(initalState)
  const prevState = useRef(initalState)

  useEffect(() => {
    prevState.current = state
  }, [])

  return [state, setState, prevState]
}

export default useStatePrev
